import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
// Straight from the module, not from the barrel — see the note in useDispatchSuccessNotification.
import { useDispatchSuccessNotification } from './useDispatchSuccessNotification';

export function useDispatchSuccessfullySavedRecord() {
    const { t } = useTranslation();
    const { dispatchSuccessNotification } = useDispatchSuccessNotification();
    // The sentence around the record name was hardcoded German, so every save in the app answered an
    // English UI in German. The name itself stays as the caller wrote it — those are technical labels
    // ("Budget Baselines", "Working Unit"), not user copy.
    const dispatchSuccessfullySavedRecord = useCallback(
        (recordName) => dispatchSuccessNotification({ message: t('notification.recordSaved', { record: recordName }) }),
        [dispatchSuccessNotification, t]
    );

    return { dispatchSuccessfullySavedRecord };
}
